import {
    getL1CategoryIdBySeoName,
    getL2CategoryIdBySeoName,
    type L1CategorySeoName,
    type L2CategorySeoName,
} from '@gumtree/shared/src/util/category-mapping';
import { getDomainFromUrl } from '@gumtree/shared/src/util/url-service';

import type { MhcCategoryItem } from './mhc-category-data';

export const buildMhcNavigationClickEvent = (
    item: MhcCategoryItem
): GA4.ClickNavigationMenu => {
    const isSubcategory = item.level === 'L2';

    return {
        event: 'click_navigation_menu',
        linkDomain: getDomainFromUrl(item.path || ''),
        linkText: item.label,
        linkURL: item.path || '',
        navigationCategory: item.seoName as L1CategorySeoName | L2CategorySeoName,
        navigationCategoryId: isSubcategory
            ? getL2CategoryIdBySeoName(item.seoName as L2CategorySeoName)
            : getL1CategoryIdBySeoName(item.seoName as L1CategorySeoName),
        navigationHeader: isSubcategory ? 'Browse by' : undefined,
        navigationHierarchy: isSubcategory ? 'sub category' : 'category',
    };
};
